<template>
    <div v-bind:class="className">
        <label class="control-label"> {{item.label}} </label>
        <textarea class="form-control margin-bottom" v-bind:value="item.value" v-on:input="update" v-bind:placeholder="item.placeholder" v-bind:name="item.name" v-bind:maxlength="item.maxlength" v-bind:cols="item.cols" v-bind:rows="item.rows" v-bind:readonly="item.readonly"></textarea>
        <div v-for="error in item.errors" v-bind:class="{'margin-left': item.type=='checkbox'}" class="to-up" id="errors">
            {{ error }}
        </div>
    </div>
</template>

<script>
export default{
    name: 'emt-textarea',
    props: {
        item: Object,
        className: String
    },
    methods: {
        update: function (event) {
            var self = this
            self.item.value = event.target.value
        }
    }
}
</script>



// WEBPACK FOOTER //
// emt-textarea.vue?7b3430bc